import axios from 'axios';

// const urlApi = process.env.REACT_APP_IBGE;

const apiIbge = axios.create({
  baseURL: 'http://servicodados.ibge.gov.br/api/v2/',
  headers: { 'Content-Type': 'application/json' },
});

apiIbge.interceptors.request.use(async (config) => {
  try {
    return config;
  } catch (error) {
    return error;
  }
});

export default apiIbge;
